import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { addMonths, format } from "date-fns";
//Icons
import { Plus, Trash } from "@phosphor-icons/react";
//Utils
import { HandleSelectedPayment } from "utils/FunctionPayment";

interface ICreat {
  register: any;
  errors: any;
  reset: any;
  resetField: any;
  control: any;
  getValues: any;
  watch: any;
  setValue: any;
}

interface IMethPay {
  id: number;
  form_payment: string;
}

export default function CreateProduct({
  register,
  errors,
  reset,
  control,
  getValues,
  watch,
  setValue
}: ICreat) {
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [paymentAmount, setPaymentAmount] = useState<number[]>([1]);
  const [formPaymentSelec, setFormPaymentSelec] = useState("");

  const discount = watch("discount") || 0;

  const addPayment = () => {
    if (paymentAmount.length < 6) {
      setPaymentAmount([...paymentAmount, paymentAmount.length + 1]);
    } else {
      alert("Tamanho atingido!");
    }
  };

  const removePayment = (indexToRemove: number) => {
    if (paymentAmount.length > 1) {
      // Atualizar o array de pagamentos
      const updatedPayments = paymentAmount.filter(
        (_, index) => index !== indexToRemove
      );
      setPaymentAmount(updatedPayments);

      // Obter os valores atuais do formulário
      const currentValues = getValues();

      // Verificar se os arrays existem antes de aplicar o filtro
      const updatedAmount = Array.isArray(currentValues.amount)
        ? currentValues.amount.filter(
          (_: any, index: number) => index !== indexToRemove
        )
        : [];
      const updatedDateId = Array.isArray(currentValues.due_date)
        ? currentValues.due_date.filter(
          (_: any, index: number) => index !== indexToRemove
        )
        : [];

      // Atualizar os campos com os valores filtrados
      reset({
        ...currentValues,
        amount: updatedAmount,
        due_date: updatedDateId,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("form-payment");
        const paymentData = response.data;

        setFormPay(paymentData);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  /**
   * Data automática
   */

  const generateDueDates = (totalPayments: number) => {
    const today = new Date();
    return Array.from({ length: totalPayments }, (_, index) => {
      const dueDate = addMonths(today, index + 1); // Incrementa os meses
      return format(dueDate, "yyyy-MM-dd"); // Formata para o padrão ISO (ano-mês-dia)
    });
  };

  const totalPayments = paymentAmount.length; // Total de parcelas
  const dueDates = generateDueDates(totalPayments); // Gera as datas automaticamente

  useEffect(() => {
    // Inicializa os valores no formulário
    dueDates.forEach((date, index) => {
      setValue(`due_date.${index}`, date);
    });
  }, [dueDates, setValue]);

  return (
    <S.Container>
      <S.Content>
        {paymentAmount.map((paymentIndex, index) => (
          <S.FormsSection
            key={paymentIndex}
            className="highlight"
          >
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Tipo
                </S.Label>
                <S.Select {...register("material_id")}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="lens">
                    Lente
                  </option>
                  <option value="frame">
                    Armação
                  </option>
                  <option value="accessory">
                    Acessório
                  </option>
                </S.Select>
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Descrição
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Quantidade
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="number"
                  {...register("code", { required: true })}
                />
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Valor R$
                </S.Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
              <S.FormInput>
                <S.Label>
                  Desconto (%)
                </S.Label>
                <Controller
                  name="profit"
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="0,00 %"
                      suffix=" %"
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Subtotal
                </S.Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
            {
              paymentAmount.length > 1 && (
                <S.ContentButton>
                  <S.ButtonRemove onClick={() => removePayment(index)}>
                    <Trash />
                    Remover
                  </S.ButtonRemove>
                </S.ContentButton>
              )
            }
          </S.FormsSection>
        ))}
      </S.Content>

      <S.ContentButton>
        <S.Button onClick={addPayment}>
          <Plus size={16} />
          Adicionar
        </S.Button>

        <S.Infor>{paymentAmount.length} Produto(s)</S.Infor>
      </S.ContentButton>
    </S.Container>
  );
}
